import { useEffect, useState } from 'react';

// Returns a debounced copy of `value` that only updates after `delay` ms
// of no changes. Used to avoid firing an API request on every keystroke.
const useDebounce = (value, delay = 500) => {
    const [debounced, setDebounced] = useState(value);

    useEffect(() => {
        const timer = setTimeout(() => setDebounced(value), delay);
        return () => clearTimeout(timer);
    }, [value, delay]);

    return debounced;
};

export default useDebounce;
